import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';

export const getEastWestHeading = (colId: string, headerName: string) => {
    return {
        colId,
        headerName,
        field: colId,
        enableRowGroup: false,
        editable: true,
        cellEditorFramework: SelectEditor,
        cellEditorParams: {
            values: ['WW', 'E', 'W'],
        },
        suppressKeyboardEvent: allowUpAndDownOnEdit(),
        cellClassRules: {
            ...commonRowAndCellClassRules,
        },
        filterParams: {
            ...defaultSetFilterParams,
        },
        hide: true,
    };
};
